import React, { Component } from 'react';
import Overview from './Overview';
import Form from './Form';
import {Switch, Route } from 'react-router-dom';
import {withRouter} from 'react-router';
import { connect } from 'react-redux'
class Files extends Component {	
  
	render() { 			
        return (
            <Switch>
                <Route exact path="/files" name="Overview" render={(location) => <Overview />}/> 
                <Route exact path="*/add" name="Toevoegen" render={(location) => <Form />}/>  
                <Route exact path="*/update/:fileId" name="Form" render={(location) => <Form />}/>            
                <Route exact path="*/add/address/:addressId" name="Form" render={(location) => <Form />}/>    
              </Switch>
        )
  	}
}

function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer, 
        searchData: state.SearchDataReducer       
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Files))



// WEBPACK FOOTER //
// ./src/views/Files/index.js